import React from "react";
import {SwatchProps} from "../types";
import {CircleCustomColorSwatch} from "./custom-color-swatches";
import {CircleImageSwatch} from "./image-swatches";

export const CircleSwatch = (props: SwatchProps) => {
  const {boxShadow, selected, size, colorName} = props;
  //  eslint-disable-next-line react/destructuring-assignment
  const customColor = "customColor" in props ? props.customColor : undefined;
  //  eslint-disable-next-line react/destructuring-assignment
  const url = "url" in props ? props.url : undefined;
  return "customColor" in props ? (
    <CircleCustomColorSwatch
      aria-hidden
      boxShadow={boxShadow}
      customColor={customColor}
      selected={selected}
      size={size}
      title={colorName}
    />
  ) : (
    <CircleImageSwatch
      aria-hidden
      boxShadow={boxShadow}
      selected={selected}
      size={size}
      src={url}
      title={colorName}
    />
  );
};
